module.exports = __webpack_public_path__ + "img/高效组件 通威智造_1.007a83e6.png";